import { combineReducers } from 'redux';
import activities from './activities';
import activityTypes from './activityTypes';
import bands from './bands';
import orgUnits from './orgUnits';
import patients from './patients';
import postings from './postings';
import referrals from './referrals';
import timeSlots from './timeSlots';
import treatmentInstances from './treatmentInstances';
import treatments from './treatments';
import visitActuals from './visitActuals';
import settings from './settings';
import nonPatientActivityTypes from './nonPatientActivityTypes';
import nonPatientActivities from './nonPatientActivities';
import referralServices from './referralServices';
import externalProviders from './externalProviders';

const entities = combineReducers({
  activities,
  activityTypes,
  bands,
  orgUnits,
  patients,
  postings,
  referrals,
  timeSlots,
  treatmentInstances,
  treatments,
  visitActuals,
  settings,
  nonPatientActivityTypes,
  nonPatientActivities,
  referralServices,
  externalProviders,
});

export default entities;
